"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function StartYourJourney() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: subtitleRef,
    isVisible: subtitleVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="start-your-journey" className="relative min-h-screen w-full overflow-hidden flex items-center justify-center bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/caregiver_child_warm_interaction.png)] animate-[ken-burns_30s_ease-out_infinite]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-black/35 backdrop-blur-[2px]" aria-hidden="true" />

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {}
        <h1 ref={titleRef} className={`text-white font-display font-bold text-4xl lg:text-6xl mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          Start Your Journey
        </h1>

        {}
        <p ref={subtitleRef} className={`text-white/90 text-lg lg:text-xl mb-10 max-w-2xl mx-auto font-sans transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${subtitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          Begin your child's path to growth and development with compassionate, evidence-based ABA therapy tailored to your family's needs.
        </p>

        {}
        <div ref={ctaRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          <Button asChild size="lg" className="bg-accent text-foreground-accent hover:bg-accent-hover active:bg-accent-active shadow-medium hover:shadow-strong hover:scale-[1.02] active:scale-[0.98] transition-all duration-[var(--duration-fast)] px-10 py-6 text-lg font-semibold rounded-[var(--radius-md)]">
            <Link to="/GetStartedPage">Request Services</Link>
          </Button>
        </div>
      </div>

      {}
      <style>{`
        @keyframes ken-burns {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.08);
          }
        }
      `}</style>
    </section>;
}